import type {
  WorkOrderPriority,
  WorkOrderServiceCategory,
  WorkOrderServiceItem,
} from '@backoffice-frontend/graphql'
import { useTranslation } from 'react-i18next'

export const useWorkOrderServiceItemTranslation = () => {
  const { t } = useTranslation()

  return (serviceItem: WorkOrderServiceItem): string => {
    const options: Record<WorkOrderServiceItem, string> = {
      CLEANING: t('vehicleCommon_workOrdersTable_serviceItem_cleaning'),
      SPECIAL_CLEANING: t(
        'vehicleCommon_workOrdersTable_serviceItem_specialCleaning',
      ),
      VEHICLE_LETTERING: t(
        'vehicleCommon_workOrdersTable_serviceItem_vehicleLettering',
      ),
      TRANSFER_RIDE: t(
        'vehicleCommon_workOrdersTable_serviceItem_transferRide',
      ),
      TABLET_UPDATE: t(
        'vehicleCommon_workOrdersTable_serviceItem_tabletUpdate',
      ),
      SEAT_COMPLAINT: t(
        'vehicleCommon_workOrdersTable_serviceItem_seatComplaint',
      ),
      SMART_REPAIR_DENT: t(
        'vehicleCommon_workOrdersTable_serviceItem_smartRepairDent',
      ),
      SMART_REPAIR_PAINTWORK: t(
        'vehicleCommon_workOrdersTable_serviceItem_smartRepairPaintwork',
      ),
      ACTION_MANUFACTURER: t(
        'vehicleCommon_workOrdersTable_serviceItem_actionManufacturer',
      ),
      ACTION_INTERNAL: t(
        'vehicleCommon_workOrdersTable_serviceItem_actionInternal',
      ),
      BRAKE_FLUID_CHANGE: t(
        'vehicleCommon_workOrdersTable_serviceItem_brakeFluidChange',
      ),
      CHARGING: t('vehicleCommon_workOrdersTable_serviceItem_charging'),
      INSIDE_CLEANING: t(
        'vehicleCommon_workOrdersTable_serviceItem_insideCleaning',
      ),
      OUTSIDE_CLEANING: t(
        'vehicleCommon_workOrdersTable_serviceItem_outsideCleaning',
      ),
      INTERNAL_INSPECTION: t(
        'vehicleCommon_workOrdersTable_serviceItem_internalInspection',
      ),
      IN_FIELD_SUPPORT: t(
        'vehicleCommon_workOrdersTable_serviceItem_inFieldSupport',
      ),
      MAIN_INSPECTION: t(
        'vehicleCommon_workOrdersTable_serviceItem_mainInspection',
      ),
      MILEAGE_INSPECTION: t(
        'vehicleCommon_workOrdersTable_serviceItem_mileageInspection',
      ),
      MAINTENANCE: t('vehicleCommon_workOrdersTable_serviceItem_maintenance'),
      OTHER: t('vehicleCommon_workOrdersTable_serviceItem_other'),
    }
    return options[serviceItem] ?? serviceItem
  }
}

export const useWorkOrderServiceCategoryTranslation = () => {
  const { t } = useTranslation()

  return (workOrderServiceCategory: WorkOrderServiceCategory): string => {
    const options: Record<WorkOrderServiceCategory, string> = {
      DAMAGES_DEFECTS: t('common_workOrdersTable_category_damagesDefects'),
      IVC: t('common_workOrdersTable_category_ivc'),
      HUB_ACTIVITIES: t('common_workOrdersTable_category_hubActivities'),
      MAINTENANCE_SERVICE: t(
        'common_workOrdersTable_category_maintenanceService',
      ),
      INCIDENT: t('common_workOrdersTable_category_incident'),
      OTHER: t('common_workOrdersTable_category_other'),
    }
    return options[workOrderServiceCategory] ?? workOrderServiceCategory
  }
}

export const usePriorityTranslation = () => {
  const { t } = useTranslation()

  return (priority: WorkOrderPriority): string => {
    const options: Record<WorkOrderPriority, string> = {
      HIGH: t('common_workOrdersTable_priority_high'),
      LOW: t('common_workOrdersTable_priority_low'),
      MEDIUM: t('common_workOrdersTable_priority_medium'),
    }
    return options[priority] ?? priority
  }
}
